import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay",
  id: "overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "./triangle.svg",
  class: "triangle",
  id: "bg-triangle"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "./Circle.svg",
  id: "bg-circle",
  class: "circle"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "./christmastree.svg",
  class: "triangle",
  id: "tree"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "./Santa.svg",
  id: "santa"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "overlay",
  id: "overlay"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "./triangle.svg",
  class: "triangle",
  id: "bg-triangle"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: "./Circle.svg",
  id: "bg-circle",
  class: "circle"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "./bunnies.svg",
  class: "triangle",
  id: "tree",
  style: {"height":"50vh"}
}, null, -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "overlay",
  id: "overlay",
  style: {"font-size":"35vh"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "./triangle.svg",
  class: "triangle",
  id: "bg-triangle"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "./Circle.svg",
  id: "bg-circle",
  class: "circle"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "./cat.svg",
  id: "cat_moon"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-ghost",
  id: "hat"
}, null, -1)
const _hoisted_17 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 3,
  class: "overlay",
  id: "overlay"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "./triangle.svg",
  class: "triangle"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "./Circle.svg",
  id: "bg-circle",
  class: "circle"
}, null, -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  class: "upper",
  style: {"width":"100vw"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { style: {"left":"1.5em","position":"absolute"} }, "/", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  style: {"right":"3vw","position":"absolute","cursor":"pointer","top":"2vh","font-size":"3vmax"},
  href: "https://hz.group"
}, " H&Z ", -1)
const _hoisted_25 = { class: "wrapper" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, "#StandWithUkraine", -1)
const _hoisted_27 = {
  id: "question-container",
  class: "question-container"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" shuffle ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-random",
  style: {"color":"white","font-size":"1.3vmax"}
}, null, -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ basic: _ctx.isBasic, primary: _ctx.isprimary }),
    id: "page"
  }, [
    _createElementVNode("div", {
      id: "primary-sky",
      class: _normalizeClass(_ctx.holiday)
    }, null, 2),
    _createElementVNode("div", {
      id: "basic-sky",
      class: _normalizeClass(_ctx.season)
    }, null, 2),
    (_ctx.holiday == 'christmas')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
      : (_ctx.holiday == 'easter')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
        : (_ctx.holiday == 'halloween')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_17))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21)),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isprimary = !_ctx.isprimary)),
        style: {"text-decoration":"underline"},
        class: "b-switch"
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.button_theme[_ctx.holiday]),
          style: {"left":"1vw","position":"absolute","cursor":"pointer","top":"2vh","font-size":"2vmax"}
        }, null, 2)
      ]),
      _createElementVNode("div", {
        style: {"left":"6vw","position":"absolute","cursor":"pointer","top":"2vh","font-size":"1.5vmax"},
        class: _normalizeClass(_ctx.language)
      }, [
        _createElementVNode("button", {
          id: "de",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.to_german()))
        }, "DE"),
        _hoisted_23,
        _createElementVNode("button", {
          id: "en",
          style: {"left":"2em","position":"absolute"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.to_english()))
        }, " EN ")
      ], 2),
      _hoisted_24
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.t == "" ? "Russian warship, go to hell": _ctx.t), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.random_text())),
        class: "b-shuffle"
      }, _hoisted_30)
    ])
  ], 2))
}